export default "__VITE_ASSET__a375cd36__"